'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * NOTE: This form does not follow the proper way to use
 * React and Symfony Forms, a better example can be found
 * by looking at ForgotPasswordForm
 */
var PaymentForm = _baseForm2['default'].createFormClass({

    displayName: 'PaymentForm',

    propTypes: {
        'stripeToken': _react2['default'].PropTypes.string,
        'planId': _react2['default'].PropTypes.string,
        'couponCode': _react2['default'].PropTypes.string,
        'timePeriod': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'card': _react2['default'].PropTypes.object,
        'isApi': _react2['default'].PropTypes.bool,
        'isEventbrite': _react2['default'].PropTypes.bool,
        'termsAccepted': _react2['default'].PropTypes.bool,
        'buttonText': _react2['default'].PropTypes.string,
        'headerText': _react2['default'].PropTypes.string,
        'billingString': _react2['default'].PropTypes.object,
        'ccExpiration': _react2['default'].PropTypes.string,
        'formAction': _react2['default'].PropTypes.string,
        'numSeats': _react2['default'].PropTypes.number,
        'currentPlanName': _react2['default'].PropTypes.string,
        'errors': _react2['default'].PropTypes.object
    },

    CARD_TYPES: [{ 'long': 'MasterCard', 'short': 'mastercard' }, { 'long': 'Visa', 'short': 'visa' }, { 'long': 'American Express', 'short': 'amex' }, { 'long': 'Discover', 'short': 'discover' }],

    getDefaultProps: function getDefaultProps() {
        return {
            'formAction': '',
            'numSeats': 1
        };
    },
    getInitialState: function getInitialState() {
        var globalError = this.props.errors && this.props.errors['payment[submit]'] || null;
        return {
            'card': $.extend({
                'expYear': new Date().getFullYear() + 1,
                'expMonth': '01',
                'number': '0',
                'cvv': '000',
                'type': 'Unknown'
            }, this.props.card),
            'isProcessing': false,
            'termsAccepted': this.props.termsAccepted || false,
            'stripeToken': this.props.stripeToken || '',
            'errors': { 'global': globalError }
        };
    },
    onContinueClick: function onContinueClick(evt) {

        evt.preventDefault();

        var card = this.state.card;

        if (!card.suffix && (!card.name || card.name.length < 1)) {
            this.setState({
                'errors': { 'global': 'Cardholder name is required.' },
                'isProcessing': false
            });
            return;
        }

        if (this.state.isProcessing === false) {

            this.setState({
                'errors': null,
                'isProcessing': true
            });

            if (this.props.isApi && !this.props.isEventbrite && this.state.termsAccepted === false) {
                this.setState({
                    'errors': { 'global': 'You need to accept the terms to sign up.' },
                    'isProcessing': false
                });
                return;
            }

            if (card.suffix) {
                this.submitForm();
                return;
            }

            Stripe.card.createToken({
                'number': card.number,
                'cvc': card.cvv,
                'exp_month': card.expMonth,
                'exp_year': card.expYear,
                'address_zip': card.zip,
                'name': card.name
            }, function (status, response) {
                if (response.error) {
                    this.setState({
                        'errors': { 'global': response.error.message },
                        'isProcessing': false
                    });
                } else {
                    var token = response.id;
                    this.setState({
                        'stripeToken': token
                    });
                    this.submitForm();
                }
            }.bind(this));
        }

        return false;
    },
    submitForm: function submitForm() {
        _logger2['default'].track('PaymentForm._onSuccess', {
            previousPlanName: this.props.currentPlanName,
            newPlanName: this.props.name
        });
        $('#payment_form').submit();
    },
    onCardType: function onCardType(event) {
        var card = this.state.card;
        card.type = Stripe.cardType(event.target.value);
        card.number = event.target.value;
        this.setState({ 'card': card });
    },
    onExpMonthChange: function onExpMonthChange(event) {
        var card = this.state.card;
        card.expMonth = event.target.value;
        this.setState({ 'card': card });
    },
    onExpYearChange: function onExpYearChange(event) {
        var card = this.state.card;
        card.expYear = event.target.value;
        this.setState({ 'card': card });
    },
    onCvvChange: function onCvvChange(event) {
        var card = this.state.card;
        card.cvv = event.target.value;
        this.setState({ 'card': card });
    },
    onZipChange: function onZipChange(event) {
        var card = this.state.card;
        card.zip = event.target.value;
        this.setState({ 'card': card });
    },
    onCardholderNameChange: function onCardholderNameChange(event) {
        var card = this.state.card;
        card.name = event.target.value;
        this.setState({ 'card': card });
    },
    onTermsChange: function onTermsChange(event) {
        this.setState({
            'termsAccepted': event.target.checked,
            'errors': null
        });
    },
    render: function render() {
        var formFields;
        var termsAgreement;
        var stripeTokenField;
        var card = this.state.card;
        var tabOffset = parseInt(this.props.tabOffset || 1000, 10);

        // Stripe token
        if (this.state.stripeToken) {
            stripeTokenField = _react2['default'].createElement('input', { type: 'hidden', name: 'payment[stripe_token]', value: this.state.stripeToken });
        }

        // Terms agreement
        if (this.props.isApi && !this.props.isEventbrite) {
            termsAgreement = _react2['default'].createElement(
                'div',
                { className: 'l-padding-b-20 columns small-12 text-left' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-payment--api-terms' },
                    _react2['default'].createElement('input', { id: 'payment_terms', type: 'checkbox', onChange: this.onTermsChange, tabIndex: tabOffset + 6, checked: this.state.termsAccepted }),
                    _react2['default'].createElement(
                        'label',
                        { htmlFor: 'payment_terms' },
                        '\xA0By using our API, you agree to our ',
                        _react2['default'].createElement(
                            'a',
                            { target: '_blank', rel: 'noopener noreferrer', href: '/api/terms' },
                            'API Terms of Service'
                        ),
                        '.'
                    )
                )
            );
        }

        var longDescription = _react2['default'].createElement(
            'div',
            { className: 'm-payment--left-border columns small-12 text-left' },
            _react2['default'].createElement(
                'p',
                null,
                this.props.billingString
            )
        );

        var cardDisplays = this.CARD_TYPES.map(function (type, i) {
            return _react2['default'].createElement('img', { key: i, src: _hfReactHelper2['default'].imgHelper('api/pricing/upgrade_popup/' + type.short + '_' + (card.type == type.long ? '' : 'in') + 'active.png') });
        }.bind(this));

        // Form fields
        if (!card.suffix) {

            var curYear = new Date().getFullYear();
            var numYears = 10;
            var yearOptions = Array.apply(null, Array(numYears)).map(function (val, offset) {
                var year = curYear + offset;
                return _react2['default'].createElement(
                    'option',
                    { value: year, key: offset },
                    year
                );
            });

            formFields = _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12 text-left' },
                        _react2['default'].createElement(
                            'p',
                            null,
                            'Enter your credit card information'
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12 large-7' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'row' },
                            _react2['default'].createElement(
                                'div',
                                { className: 'columns small-12' },
                                _react2['default'].createElement('input', { type: 'text', placeholder: 'Cardholder Name', className: 'm-payment--cardholder-name columns small-8', value: card.name, onChange: this.onCardholderNameChange, tabIndex: tabOffset })
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'row' },
                            _react2['default'].createElement(
                                'div',
                                { className: 'columns small-12 m-payment--cc' },
                                _react2['default'].createElement('input', { type: 'text', placeholder: 'Credit card number', onInput: this.onCardType, tabIndex: tabOffset + 1 }),
                                _react2['default'].createElement(
                                    'div',
                                    { className: 'm-payment--ccs show-for-medium-up' },
                                    cardDisplays
                                )
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'row' },
                            _react2['default'].createElement(
                                'div',
                                { className: 'columns small-12 large-6 small-text-left large-text-right' },
                                _react2['default'].createElement(
                                    'select',
                                    { className: 'm-payment--cc-exp-month columns small-4', value: card.expMonth, onChange: this.onExpMonthChange, tabIndex: tabOffset + 2 },
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '01' },
                                        '01'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '02' },
                                        '02'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '03' },
                                        '03'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '04' },
                                        '04'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '05' },
                                        '05'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '06' },
                                        '06'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '07' },
                                        '07'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '08' },
                                        '08'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '09' },
                                        '09'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '10' },
                                        '10'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '11' },
                                        '11'
                                    ),
                                    _react2['default'].createElement(
                                        'option',
                                        { value: '12' },
                                        '12'
                                    )
                                ),
                                _react2['default'].createElement(
                                    'select',
                                    { className: 'm-payment--cc-exp-year columns small-8', value: card.expYear, onChange: this.onExpYearChange, tabIndex: tabOffset + 3 },
                                    yearOptions
                                )
                            ),
                            _react2['default'].createElement(
                                'div',
                                { className: 'columns small-12 large-6 large-text-left small-text-right' },
                                _react2['default'].createElement('input', { type: 'text', placeholder: 'CVV', className: 'm-payment--cvv columns small-4', onChange: this.onCvvChange, tabIndex: tabOffset + 4 }),
                                _react2['default'].createElement('input', { type: 'text', placeholder: 'Zip code', name: 'payment[cc_zip]', className: 'm-payment--zip columns small-8', onChange: this.onZipChange, tabIndex: tabOffset + 5 })
                            )
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12 large-5' },
                        longDescription
                    )
                )
            );
        } else if (this.props.monthlyExpectedRate == 0) {
            formFields = _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12 text-left' },
                        _react2['default'].createElement(
                            'p',
                            null,
                            this.props.billingString
                        )
                    )
                )
            );
        } else {
            formFields = _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12 text-left' },
                        _react2['default'].createElement(
                            'p',
                            null,
                            'The following card will be charged:'
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12 text-left' },
                        _react2['default'].createElement(
                            'h4',
                            null,
                            'xxxx xxxx xxxx ',
                            this.state.card.suffix
                        ),
                        _react2['default'].createElement(
                            'h4',
                            null,
                            'Expires ',
                            this.props.ccExpiration,
                            ' '
                        )
                    ),
                    longDescription
                )
            );
        }

        return _react2['default'].createElement(
            'div',
            { className: 'm-payment' },
            _react2['default'].createElement(
                'form',
                { id: 'payment_form', action: this.props.formAction, method: 'POST', onSubmit: this.onContinueClick },
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12 text-center l-padding-v-20' },
                        _react2['default'].createElement(
                            'h3',
                            null,
                            this.props.headerText
                        )
                    )
                ),
                formFields,
                _react2['default'].createElement(
                    'div',
                    { className: 'row l-margin-v-10' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12 large-7 text-left m-payment--error' },
                        this.renderErrorText()
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'row l-padding-v-20' },
                    termsAgreement,
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12 text-center' },
                        _react2['default'].createElement(_button2['default'], { onClick: this.onContinueClick,
                            buttonText: this.props.buttonText || 'Continue',
                            buttonColor: 'grasshopper',
                            buttonHoverColor: 'castle-rock',
                            buttonTabIndex: tabOffset + 7 })
                    )
                ),
                stripeTokenField,
                this.renderCsrfField(),
                _react2['default'].createElement('input', { type: 'hidden', name: 'cardHolderName', value: card.name }),
                _react2['default'].createElement('input', { type: 'hidden', name: 'payment[num_seats]', value: this.props.numSeats }),
                _react2['default'].createElement('input', { type: 'hidden', name: 'payment[target_plan]', value: this.props.planId }),
                _react2['default'].createElement('input', { type: 'hidden', name: 'payment[coupon_code]', value: this.props.couponCode || '' }),
                _react2['default'].createElement('input', { type: 'hidden', name: 'payment[period]', value: this.props.timePeriod })
            )
        );
    }
});

module.exports = PaymentForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-form.jsx
 ** module id = 1063
 ** module chunks = 0
 **/